'use strict';

import Backbone from 'backbone';
import config from '../../js/config';
import Analytics from  '../Analytics/Analytics';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
import $ from 'jquery';

var ArwPrmView = Backbone.View.extend({

  events: {
    'click .ArwPrm-link': 'pushPromoAnalyticsData',
    'click .ArwPrm-footer-button': 'pushPromoAnalyticsData'
  },

  pushPromoAnalyticsData: function(event) {
    event.preventDefault();
    this.redirectUrl = event.target.getAttribute('href');
    this.redirectTarget = event.target.getAttribute('target');
    this.analyticsData = $(event.target).data('analytics');
    if (this.analyticsData) {
      let promoData = {
        event: config.analytics.eventTypes.PromoClick,
        id: this.analyticsData.PromotionId,
        name: this.analyticsData.PromotionName,
        creative: this.analyticsData.PromotionCreative,
        position: this.analyticsData.PromotionPosition
      }
      Analytics.pushToECommercePromotionalEventFramework(promoData);
    }
    if (EnableAdobeAnalytics.isEnabled() && this.redirectUrl) {
      Analytics.pushFormInteractionData('form_submit', 'Vertical content sign-up form');
    }
    window.open(this.redirectUrl, this.redirectTarget);
  }

});

export function createArwPrmView($parent) {
  let $element = $parent.find('.ArwPrm');
  if ($element.length) {
    new ArwPrmView({ el: $element });
  }
}



// WEBPACK FOOTER //
// ./assets/components/ArwPrm/ArwPrmView.js